import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-82" data-mp="26mmawj50yzj7">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-83" data-mp="22lkc23f0sphr">
        <SectionHeading eyebrow="The shift" title="From a dentist who has to remember everything, to a professional who has a system" data-id="element-84" data-mp="22iy3q1kb25yh" />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-85" data-mp="2ud8jqcmusnu9">
          <div className="flex flex-col rounded-3xl border border-red-100 bg-red-50/60 p-5 sm:p-7" data-id="element-86" data-mp="2q9u0ld3mbrcl">
            <div className="mb-5 flex items-center gap-2" data-id="element-87" data-mp="2lc20hvstkyxb">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-red-500 text-white" data-id="element-88" data-mp="2ldlh5nie1bzm">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="19w3kt934zen4" />
              </span>
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-red-700 sm:text-xl" data-id="element-90" data-mp="19y6mwrhkcy87">
                Before
              </h3>
            </div>
            <ul className="flex flex-col gap-3" data-id="element-91" data-mp="1c35psoauqtfn">
              {beforeItems.map(item => <li key={item} className="flex gap-2.5 text-sm text-navy-700 sm:text-base" data-id="element-92" data-mp="y3wdhzprojgy">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-93" data-mp="132pnvj9rbucw" />
                  <span data-id="element-94" data-mp="t5l1bic01wvk">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl border border-navy-100 bg-navy-50 p-5 sm:p-7" data-id="element-95" data-mp="fe6gd5yj7llv">
            <div className="mb-5 flex items-center gap-2" data-id="element-96" data-mp="jfic7t80132i">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-sky-500 text-white" data-id="element-97" data-mp="jg1j8ew4271r">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="5i3hqa2w253o" />
              </span>
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-navy-800 sm:text-xl" data-id="element-99" data-mp="aebslba1zc51">
                With the system
              </h3>
            </div>
            <ul className="flex flex-col gap-3" data-id="element-100" data-mp="27cr73selsova">
              {afterItems.map(item => <li key={item} className="flex gap-2.5 text-sm text-navy-700 sm:text-base" data-id="element-101" data-mp="23d0hvt4q6gsv">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-500" aria-hidden="true" data-id="element-102" data-mp="1ydxf6fc7wmo2" />
                  <span data-id="element-103" data-mp="2r1jtahj2n9p6">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-104" data-mp="2m26ynalykyc1">
          <CTAButton label="I want a structured aligner system" data-id="element-105" data-mp="2m0m1dd89f1ah" />
        </div>
      </div>
    </section>;
}